export type ProcessEnv = Record<string, string>;
export const PUBLIC_ENV_KEY = '__ENV' as const;

// Extend Window interface to include our custom property
declare global {
    interface Window {
        [PUBLIC_ENV_KEY]: ProcessEnv;
    }
}
